export default __webpack_public_path__ + "static/media/shore_r.199bd058.webp";